module.exports = __webpack_public_path__ + "img/es.dae16f90.svg";